import { Media } from 'enums';
import { Text } from 'view/atoms';
import styled from 'styled-components';

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${Media.tablet} {
    max-width: 320px;
    min-height: 274px;
  }

  @media ${Media.notebook} {
    max-width: 385px;
  }
`;

export const Title = styled(Text)`
  line-height: 127%;
  margin-top: 20px;
  margin-bottom: 14px;
  text-align: center;

  max-width: 300px;

  @media ${Media.notebook} {
    max-width: none;
    margin-top: 30px;
  }
`;

export const Description = styled(Text)`
  text-align: center;
  line-height: 142%;
`;
